import React from "react";
import { LlmQuickWinsContext } from "./context";

export const useLlmQuickWinsProvider = () => {
  const context = React.useContext(LlmQuickWinsContext);
  if (!context) {
    throw new Error(
      "useLlmQuickWinsProvider must be used within a LlmQuickWinsProvider"
    );
  }

  return context;
};
